import { INote } from '../interfaces/entity';
import { Note } from './note';

export interface ISubjectNoteList{
  items: SubjectNote[];
  totalCount: number;
}

export class SubjectNote implements INote{
  id: number;
  uid: string;
  subjectId: number;
  noteId: number;
  sequenceId: number;
  note: Note;
  readOnly: boolean;

  constructor(subjectId: number, note?, subjectNote?, sequenceId?: number, readOnly?: boolean)
  {
      note = note || {};
      subjectNote = subjectNote || {}; 
      this.id = subjectNote.id;
      this.uid = subjectNote.uid; 
      this.subjectId = subjectId || subjectNote.subjectId;
      this.noteId = note.id || subjectNote.noteId;
      this.sequenceId = sequenceId || subjectNote.sequenceId;
      this.note = note || subjectNote.note;
      this.readOnly = readOnly;
  }
}
